<template>
  <div
    id="myCanvas"
    ref="canvasController"
    class="canvas-controller"
    @contextmenu="canvasClicked()"
  >
    <div ref="joint" class="jsPlumb-canvas">
      <Node
        ref="myNodes"
        v-for="node in nodes"
        :key="node._id"
        :id="node._id"
        :excludedNode="excludedNode"
        :showConnectionAction="showConnectionAction"
        :nodeSelected="node"
        :isSelected="node === selectedNode"
        :maxZIndex="maxZIndex"
        :defaultZIndex="defaultZIndex"
        @onUpdateSelection="updateSelection($event)"
        @onUpdateNodeSelected="updateNodeSelected"
        @onUpdateDelete="onUpdateDelete($event)"
        @onUpdateClone="onUpdateClone($event)"
        @hideContextMenu="testevent()"
        @contextMenuClick="hideMenuLink()"
        @onConnectNode="onConnectNode($event)"
        @onConnectionAnchor="onConnectionAnchor($event)"
        @onDropUpdateData="onDropUpdateData()"
        @onUpdateNode="onUpdateNode($event)"
      />
      <v-menu
        v-model="this.$store.state.showMenuLink"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        close-on-content-click
        :min-width="200"
        class="v-menu-canvas-link"
      >
        <v-list-item
          @click="deleteLinkConnection(connection)"
          style="background-color: white"
        >
          <v-list-item-icon>
            <v-icon v-text="iconTitle"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Supprimer lien</v-list-item-title>
        </v-list-item>
      </v-menu>
    </div>
  </div>
</template>

<script>
// import svgPanZoom from 'svg-pan-zoom';
// import panzoom from 'panzoom';

import Panzoom from "@panzoom/panzoom";
import { mapActions } from "vuex";

import Node from "./Node";

export default {
  components: {
    Node,
  },
  data() {
    return {
      selected: false,
      selectedWithAll: false,
      outConnections: null,
      inConnections: null,
      x: 0,
      y: 0,
      connection: null,
      iconTitle: "mdi-delete",
      browserZoomLevel: null,
      _boundedResize: null,
      nodeStartConection: null,
      nodeEndConection: null,
      selectedElements: [],
      anchorStartConnection: null,
      anchorEndConnection: null,
      outlinedNode: null,
      excludedNode: null,
      showConnectionAction: false,
      shouldCreateLinks: false,
      panzoom: null,

      selectedNode: null, // Node actuellement sélectionné
      maxZIndex: 100, // Z-index pour les nœuds sélectionnés
      defaultZIndex: 10, // Z-index pour les nœuds non sélectionnés
    };
  },

  mounted() {
    document.addEventListener('click', this.canvasClicked);
    localStorage.removeItem('panzoom_position');
    // Force reset canvas
    if (this.$route.params.skillId) {
      this.skillId = this.$route.params.skillId;
    }
    this.resetCanvas();
    // Init canvas
    this.canvas = this.$jsPlumb.getInstance({
      
      PaintStyle: {
        strokeWidth: 4,
        stroke: "black",
      },
      Container: this.$refs.joint,
    });
    this.canvas.registerConnectionTypes({
      basic: {
        paintStyle: { stroke: "black", strokeWidth: 4 },
        hoverPaintStyle: { strokeWidth: 10 },
      },
      selected: {
        paintStyle: { stroke: "black", strokeWidth: 10 },
        hoverPaintStyle: { stroke: "red" },
      },
    });
    this._boundedResize = this.resize.bind(this); // Store in a var in order to remove it later
    window.addEventListener("resize", this._boundedResize);

  this.canvas.bind("connection", (info) => {
    const sourceElement = document.getElementById(info.connection.getParameter("_idSource"));
    const targetElement = document.getElementById(info.connection.getParameter("_idTarget"));

    if (sourceElement && targetElement) {
      // Both source and target elements exist, proceed with connection creation
      info.connection.getParameter("contextSource").isActive = true;
      info.connection.getParameter("contextTarget").isActive = true;

      info.connection.addOverlay([
        "Custom",
        {
          create: () => {
            const el = document.createElement("button");
            const el2 = document.getElementsByClassName("jtk-connector");
            el.innerHTML = "X";
            el.className = "canvas-conn-remove";

            el.addEventListener("click", () => {
              this.canvas.deleteConnection(info.connection);
            });

            const links = [...el2];
            const link = links.find((link) => link._jsPlumb.id === info.connection.id);
            if (link) {
              link.addEventListener(
                  "contextmenu",
                  (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.connection = info.connection;
                    document.getElementsByClassName("v-menu-canvas")[0].hidden = true;
                    this.x = event.pageX;
                    this.y = event.pageY;
                    this.$store.commit('setShowMenuLink', true);
                    this.hideMenuLink()
                  },
                  false
              );
            }
            return el;
          },
          location: 0.5,
        },
      ]);

      if(this.shouldCreateLinks) {
        const skillId = this.$route.params.skillId;
        this.createLink({
          from: info.connection.getParameter("_idSource"),
          to: info.connection.getParameter("_idTarget"),
          
          skill: skillId,
        }).then(() => {
          info.connection.repaint();
        });
      }
    } else {
      console.warn("Source or target element not found. Connection not established.");
    }
  });


    this.canvas.bind("connectionDetached", (info) => {
      const contextSource = info.connection.getParameter("contextSource");

      const link = {
        from: info.connection.getParameter("_idSource"),
        to: info.connection.getParameter("_idTarget"),
        skill: this.$route.params.skillId
      };

      this.deleteLink(link)
          .then(() => {
            const allPromise = contextSource.getLinks(this.$route.params.skillId)
            const fromPromise = this.getAnchorLinks(link.from);
            const toPromise = this.getAnchorLinks(link.to);
            return Promise.all([allPromise, fromPromise, toPromise])
          }).then((values) => {
            const allLinks = values[0];
            const fromLinks = values[1];
            const toLinks = values[2];

            if (fromLinks.length === 0) {
              this.outConnections = allLinks.filter((elt) => elt.from === link.from).length;
            }
            if (toLinks.length === 0) {
              this.inConnections = allLinks.filter((elt) => elt.to === link.to).length;
            }
            contextSource.isActive = this.outConnections > 0 && this.inConnections > 0;
          })
    });

    this.canvas.bind("beforeDrop", () => {});

    this.canvas.bind("connectionMoved", (info) => {
      const link = {
        from: info.originalSourceId,
        to: info.originalTargetId,
      };

      this.deleteLink(link).then(() => {
        // this.getAnchorLinks(newContextSource.id).then(newContextSourceLinks => {
        //   if (newContextSourceLinks.length === 0) {
        //     newContextSource.isActive = false;
        //   }
        // });
        // this.getAnchorLinks(newContextTarget.id).then(newContextTargetLinks => {
        //   if (newContextTargetLinks.length === 0) {
        //     newContextTarget.isActive = false;
        //   }
        // });
        // this.getAnchorLinks(oldContextSource.id).then(oldContextSourceLinks => {
        //   if (oldContextSourceLinks.length === 0) {
        //     oldContextSource.isActive = false;
        //   }
        // });
        // this.getAnchorLinks(oldContextTarget.id).then(oldContextTargetLinks => {
        //   if (oldContextTargetLinks.length === 0) {
        //     oldContextTarget.isActive = false;
        //   }
        // });
      });
    });

    // Init PanZoom using CSS (GPU computing)
    this.panzoom = Panzoom(this.$refs.canvasController, {
      contain: "outside",
      maxScale: 1.3,
      minScale: 0.5,
      excludeClass: "pertimm-node",
    });

    const parent = this.$refs.canvasController.parentElement;
    parent.addEventListener('wheel', this.panzoom.zoomWithWheel);
    // This demo binds to shift + wheel
    parent.addEventListener('wheel', function(event) {
      if (!event.shiftKey) return
      this.panzoom.zoomWithWheel(event)
    });

    // Add event listener for panend to save the position
    // Function to save the current pan position
    const savePanPosition = () => {
      const { x, y } = this.panzoom.getPan();
      const panPosition = { x, y };
      localStorage.setItem("panzoom_position", JSON.stringify(panPosition));
    };

    // Add a mouseup event listener to the element you want to watch for pan changes
    this.$refs.canvasController.addEventListener("panzoompan", savePanPosition);

    // Check if there are saved coordinates
    const savedPosition = JSON.parse(localStorage.getItem("panzoom_position"));
    let retrievedNodes = null;
    // Load nodes
    console.log("skillId", this.$route.params.skillId)

    /*if (this.$route.params.skillId)
      this.getNodes(this.$route.params.skillId)
          .then((nodes) => {
            retrievedNodes = nodes;
            const promises = nodes.map((node) => this.addNodeToCanvas(node));
            return Promise.all(promises);
          })
          .then(() => {
            if (savedPosition && savedPosition.x !== 0 && savedPosition.y !== 0) {
              this.panzoom.pan(savedPosition.x, savedPosition.y);
            } else {
              const firstNode = retrievedNodes?.find(
                  (node) => !node?.anchors?.find((anchor) => anchor.name === "in")
              );
              this.panzoom.pan(
                  -firstNode?.position?.x + 400 || -4500,
                  -firstNode?.position?.y + 500 || -4500
              );
            }
            return this.getLinks(this.$route.params.skillId);
          })
          .then((links) => {
            // Créez un interval pour vérifier chaque seconde si tous les éléments sont prêts.
            const checkInterval = setInterval(() => {
              const notReadyLinks = links.find((link) => {
                const sourceElement = document.getElementById(link.from);
                const targetElement = document.getElementById(link.to);
                return !(sourceElement && targetElement);
              });
              if (notReadyLinks) {
                console.error("Ces liens ne sont pas encore prêts :", notReadyLinks);
                clearInterval(checkInterval);
              }
              else {
                links.forEach((link) => {
                  this.connectElements(link);
                });
                clearInterval(checkInterval);
              }
            }, 1000);
          })
          .catch((error) => {
            console.error("Une erreur s'est produite : ", error);
          });*/

    if (this.$route.params.skillId) {
      // Charger les nœuds et les liens en parallèle
      Promise.all([
        this.getNodes(this.$route.params.skillId), // Récupérer les nœuds
        this.getLinks(this.$route.params.skillId), // Récupérer les liens
      ])
          .then(([nodes, links]) => {
            // Traitement des nœuds
            retrievedNodes = nodes;
            const nodePromises = nodes.map((node) => this.addNodeToCanvas(node));

            // Attendre que tous les nœuds soient ajoutés au canvas
            return Promise.all(nodePromises).then(() => {
              // Gérer le positionnement (pan) des nœuds
              if (savedPosition && savedPosition.x !== 0 && savedPosition.y !== 0) {
                this.panzoom.pan(savedPosition.x, savedPosition.y);
              } else {
                const firstNode = retrievedNodes.find(
                    (node) => !node?.anchors?.find((anchor) => anchor.name === "in")
                );
                this.panzoom.pan(
                    -firstNode?.position?.x + 400 || -4500,
                    -firstNode?.position?.y + 500 || -4500
                );
              }

              return links;
            });
          })
          .then((links) => {
            // Utiliser une promesse pour vérifier si les éléments sont prêts
            const waitForElements = (link) => {
              return new Promise((resolve) => {
                const checkElementsReady = () => {
                  const sourceElement = document.getElementById(link.from);
                  const targetElement = document.getElementById(link.to);

                  if (sourceElement && targetElement) {
                    resolve(); // Les éléments sont prêts
                  } else {
                    setTimeout(checkElementsReady, 100); // Réessayer après un court délai
                  }
                };
                checkElementsReady();
              });
            };

            // Créer les liens une fois que tous les éléments sont prêts
            const linkPromises = links.map((link) => {
              return waitForElements(link).then(() => {
                this.connectElements(link); // Connecter les éléments une fois prêts
              });
            });

            return Promise.all(linkPromises); // Attendre que tous les liens soient créés
          })
          .catch((error) => {
            console.error("Une erreur s'est produite : ", error);
          });
    }

    this.selectAllNodes = (e) => {
      const tabNodes = this.$refs.myNodes;

      // select all nodes
      if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
        for (let node of tabNodes) {
          const tmpID = node.$el.id;
          const tmpNode = document.getElementById(tmpID);
          tmpNode.classList.add("selected");
          this.canvas.addToDragSelection(tmpID);

          let foundNodeAnchors = node.node.anchors.map(
            (element) => element._id
          );

          const links = [...document.getElementsByClassName("jtk-connector")];
          const filtredLinks = links.filter(
            (link) =>
              foundNodeAnchors.includes(link._jsPlumb.sourceId) ||
              foundNodeAnchors.includes(link._jsPlumb.targetId)
          );

          this.selectedElements[node._self.id] = {
            canvasId: node.$el.id,
            links: filtredLinks,
          };
        }
      }

      // unselect all nodes
      if (e.keyCode === 27) {
        localStorage.removeItem('selectedNodes');
        for (let node of tabNodes) {
          const tmpID = node.$el.id;
          const tmpNode = document.getElementById(tmpID);
          tmpNode.classList.remove("selected");
          this.canvas.removeFromDragSelection(tmpID);

          delete this.selectedElements[node._self.id];
        }

        // Reset all link widths
        const links = [...document.getElementsByClassName("jtk-connector")];
        if (links) {
          links.forEach((link) => {
            link.children[0].style.strokeWidth = "4px";
          });
        }

        this.anchorStartConnection = null;
        this.anchorEndConnection = null;
      }
    };

    document.addEventListener("keydown", this.selectAllNodes.bind(this));
  },
  async beforeMount() {
    await this.loadAnchorTypes(this.$store);
  },
  destroyed() {
    window.removeEventListener("resize", this._boundedResize);
  },
  /*updated() {
    // Minimize excessive growth of canvas by restricting its size to 100%
    const myCanvas = document.getElementById("myCanvas");
    myCanvas.style.width = "100%";
    myCanvas.style.height = "100%";
  },*/
  updated() {
    const xPositions = [];
    const yPositions = [];
    if (this.nodes.length !== 0) {
      for (var i = 0; i < this.nodes.length; i++) {
        var x = this.nodes[i].position.x;
        var y = this.nodes[i].position.y;
        xPositions.push(x);
        yPositions.push(y);
      }
      const numWidth = 5000 + Math.max(...xPositions);
      const numHeight = 5000 + Math.max(...yPositions);
      this.width = numWidth.toString() + "px";
      this.height = numHeight.toString() + "px";

      const myCanvas = document.getElementById("myCanvas");
      myCanvas.style.width = this.width;
      myCanvas.style.height = this.height;
    }
  },
  beforeDestroy() {
    localStorage.removeItem("canvasPosition");
    localStorage.removeItem("selectedNodes");
    localStorage.removeItem('panzoom_position');
    document.removeEventListener("keydown", this.selectAllNodes);
    window.removeEventListener("panzoompan", this.clearCanvasPosition);
  },
  methods: {
    ...mapActions({
      getNodes: "http/nodes/getNodes",
      addNodeToCanvas: "canvas/addNode",
      createCanvas: "canvas/createCanvas",

      createLink: "http/links/createLink",
      deleteLink: "http/links/removeLink",
      getLinks: "http/links/getLinks",
      getAnchorLinks: "http/anchors/getAnchorLinks",

      resetCanvas: "canvas/resetCanvas",
      loadAnchorTypes: "http/anchors/loadAnchorTypes"
    }),

    updateNodeSelected(node) {
      // Met à jour le nœud sélectionné
      this.selectedNode = node;
    },
    connectElements(link) {
      const sourceElement = document.getElementById(link.from);
      const targetElement = document.getElementById(link.to);

      this.canvas.connect({
        source: sourceElement,
        target: targetElement,
        overlays: [
          ["Custom", {
            create: () => {
              const el = document.createElement("button");
              el.innerHTML = "X";
              el.className = "canvas-conn-remove";
              el.addEventListener("click", () => {
                let conn = this.canvas.getConnections({ source: sourceElement, target: targetElement });
                if (conn[0]) {
                  this.canvas.deleteConnection(conn[0]);
                }
              });
              return el;
            },
            location: 0.5,
          }]
        ]
      });
    },

    // connectElements(link, trial = 0){
    //   let sourceElement = document.getElementById(link.from);
    //   let targetElement = document.getElementById(link.to);
    //
    //   if (!sourceElement || !targetElement) {
    //     if (trial <= 3) {
    //       setTimeout(() => this.connectElements(link, trial + 1), 500);  // Attendre 0.5s avant un nouvel essai
    //     } else {
    //       console.error(`Les éléments source/target n'ont pas été trouvés après 3 essais. Abandon.`);
    //     }
    //   } else {
    //     this.canvas.connect({
    //       source: sourceElement,
    //       target: targetElement,
    //       overlays: [
    //         ["Custom", {
    //           create: () => {
    //             const el = document.createElement("button");
    //             el.innerHTML = "X";
    //             el.className = "canvas-conn-remove";
    //             el.addEventListener("click", () => {
    //               let conn = this.canvas.getConnections({ source: sourceElement, target: targetElement });
    //               if (conn[0]) {
    //                 this.canvas.deleteConnection(conn[0]);
    //               }
    //             });
    //             return el;
    //           },
    //           location: 0.5,
    //         }]
    //       ]
    //     });
    //   }
    // },

    updateSelection(value) {
      let nodes = this.$refs.myNodes;
      const currentNode = document.getElementById(value);
      let foundNode = nodes.find((node) => node.$el.id === currentNode.id);

      // Retrieve the array of selected nodes from localStorage
      let selectedNodes = [];
      const storedNodes = localStorage.getItem('selectedNodes');
      if (storedNodes) {
        try {
          selectedNodes = JSON.parse(storedNodes);
        } catch (error) {
          console.error('Error parsing stored nodes:', error);
        }
      }

      let foundNodeAnchors = foundNode.node.anchors.map((element) => element._id);

      const links = [...document.getElementsByClassName("jtk-connector")];
      const filtredLinks = links.filter(
        (link) =>
          foundNodeAnchors.includes(link._jsPlumb.sourceId) ||
          foundNodeAnchors.includes(link._jsPlumb.targetId)
      );

      this.selectedElements[foundNode._self.id] = {
        canvasId: foundNode.$el.id,
        links: filtredLinks,
      };


      // console.log("filtredLinks : ", filtredLinks);
      // Update selectedNodes array based on the current selection
      if (!currentNode.classList.contains("selected")) {
        currentNode.classList.add("selected");
        this.canvas.addToDragSelection(value);
        let nodeToDuplicate = {...foundNode.node};
        delete nodeToDuplicate._id;
        delete nodeToDuplicate.updatedAt;
        let linksToDuplicate = []
        if(filtredLinks.length > 0) {
          filtredLinks.forEach(link => {
            linksToDuplicate.push({
              from: link._jsPlumb.sourceId,
              to: link._jsPlumb.targetId
            })
          })
        }
        let elementTmp = {skillId: this.$route.params.skillId, nodeId: foundNode.id, node: nodeToDuplicate, links: linksToDuplicate};
        if (!selectedNodes.includes(elementTmp)) {
          selectedNodes.push(elementTmp);
        }
      } else {
        delete this.selectedElements[foundNode._self.id];
        currentNode.classList.remove("selected");
        this.canvas.removeFromDragSelection(value);
        // If the current node is deselected, remove its ID from the array
        selectedNodes = selectedNodes.filter((element) => element.nodeId !== foundNode.id);
      }

      // Store the updated array back to localStorage
      try {
        localStorage.setItem('selectedNodes', JSON.stringify(selectedNodes));
      } catch (error) {
        console.error('Error storing selected nodes:', error);
      }

      let allConnections = this.canvas.getConnections();
      const filtredConnections = allConnections.filter(
        (connection) =>
          foundNodeAnchors.includes(connection.sourceId) ||
          foundNodeAnchors.includes(connection.targetId)
      );

      let uniqueSelectedElements = [
        ...new Set(
          [].concat(
            ...Object.values(this.selectedElements).map((el) => el.links)
          )
        ),
      ];

      for (let link in filtredConnections) {
        if (uniqueSelectedElements.includes(filtredConnections[link].canvas)) {
          filtredConnections[link].setType("selected");
        } else {
          filtredConnections[link].setType("basic");
        }
      }
    },

    resize: function() {
      this.browserZoomLevel =
        Math.round(window?.devicePixelRatio * 100) || null;
    },
    onUpdateDelete(node) {
      // console.log("removing node form canvas", node._id);
      let allOutConnections = [];
      let allInConnections = [];
      for (let i = 0; i < node.anchors.length; i++) {
        if (node.anchors[i].out) {
          let outConnections = this.canvas.getConnections({
            //only one of source and target is needed, better if both setted
            source: document.getElementById(node.anchors[i]._id),
          });
          if(outConnections.length > 0) {
            for(let i = 0; i < outConnections.length; i++) {
              for(const node of this.$refs.myNodes) {
                if(node.$refs?.anchorIn) {
                  let anchor = node.$refs?.anchorIn[0];
                  if(anchor.$options.propsData.id === outConnections[i].targetId) {
                    let inTargetNodeConnections = this.canvas.getConnections({
                      //only one of source and target is needed, better if both setted
                      target: document.getElementById(outConnections[i].targetId),
                    });
                    if(inTargetNodeConnections.length <= 1) {
                      anchor.isActive = false;
                    }
                  }
                }
              }
            }

          }
          allOutConnections = allOutConnections.concat(outConnections);
        } else {
          allInConnections = this.canvas.getConnections({
            //only one of source and target is needed, better if both setted
            target: document.getElementById(node.anchors[i]._id),
          });
          if(allInConnections.length > 0) {
            for(let i = 0; i < allInConnections.length; i++) {
              for(const node of this.$refs.myNodes) {
                if(node.$refs.anchorOut.length === 1) {
                  let anchor = node.$refs.anchorOut[0];
                  if(anchor.$options.propsData.id === allInConnections[i].sourceId) {
                    anchor.isActive = false;
                  }
                } else {
                  let anchor = node.$refs.anchorOut.filter(anchorElement => {
                    return anchorElement.$options.propsData.id === allInConnections[i].sourceId;
                  })
                  if(anchor.length > 0) anchor[0].isActive = false;
                }
              }
            }
          }
        }
      }

      let allConnectionsToDelete = [...allInConnections, ...allOutConnections];
      for (const connection of allConnectionsToDelete) {
        this.deleteLinkConnection(connection);
      }
      const index = this.nodes.findIndex((f) => f._id === node._id);
      this.nodes.splice(index, 1);
    },
    onUpdateClone(node) {
      this.nodes.push(node);
    },
    testevent() {
      this.$emit("hideContextMenu", true);
    },
    hideMenuLink() {
      this.$bus.$emit("contextMenuClick", true)
    },
    canvasClicked() {
      this.$emit("canvasClicked");
      if (this.$store.state.showMenuLink) {
        this.$store.commit('setShowMenuLink', false)
      }
    },
    deleteLinkConnection(connection) {
      this.canvas.deleteConnection(connection);
      this.$store.commit('setShowMenuLink', false)
      this.connection = null;
    },
    onConnectNode($event) {
      this.excludedNode = null;
      this.showConnectionAction = false;
      this.shouldCreateLinks = true;
      if (this.nodeStartConection == null) {
        if (this.anchorStartConnection) {
          let anchorEndConnection = $event.anchors.find((anchor) => {
            return anchor.name === "in";
          });
          this.canvas.connect({
            source: this.anchorStartConnection,
            target: anchorEndConnection._id,
            
            hoverPaintStyle: { strokeWidth: "10px" },
          });
          if (this.outlinedNode) {
            let outlinedNode = document.getElementById(this.outlinedNode);
            outlinedNode.style.border = "";
          }
          this.anchorStartConnection = null;
        } else {
          this.nodeStartConection = $event;
        }
      } else if (this.nodeStartConection && this.nodeEndConection == null) {
        this.nodeEndConection = $event;
      }
      if (this.nodeStartConection && this.nodeEndConection) {
        let outAnchor = this.nodeStartConection.anchors.find((anchor) => {
          return anchor.out === true;
        });
        let inAnchor = this.nodeEndConection.anchors.find((anchor) => {
          return anchor.name === "in";
        });
        if (outAnchor && inAnchor) {
          this.canvas.connect({
            source: document.getElementById(outAnchor._id),
            target: document.getElementById(inAnchor._id),
            
            hoverPaintStyle: { strokeWidth: "10px" },
          });
        }
        this.nodeStartConection = null;
        this.nodeEndConection = null;
      }
      this.shouldCreateLinks = false;
    },
    onUpdateNode(e){
      let connections = this.canvas.getConnections({source: e.anchors.in[0]._id});
      let anchorInfo = connections.map(conn => conn.endpoints);
      anchorInfo.forEach(info => {
        this.canvas.connect({
          source: info.sourceEndpoint.elementId,
          target: info.targetEndpoint.elementId,
          // spécifier le reste de vos options ici
        });
      });

      this.canvas.repaintEverything();// this will cause a repaint
    },
    onConnectionAnchor(event) {
      this.showConnectionAction = true;
      this.shouldCreateLinks = true;
      if (this.anchorStartConnection == null) {
        this.excludedNode = event?.nodeId;
        this.anchorStartConnection = event.anchor;
        const currentNode = document.getElementById(event.node);
        currentNode.style.border = "solid 2px";
        this.outlinedNode = event.node;
      } else if (
        this.anchorStartConnection &&
        this.anchorEndConnection == null
      ) {
        if (event.anchorOutState) {
          alert("Impossible To connect two out anchors!");
        } else {
          this.anchorEndConnection = event.anchor;
        }
      }

      if (this.anchorStartConnection && this.anchorEndConnection) {
        this.canvas.connect({
          source: this.anchorStartConnection,
          target: this.anchorEndConnection,
          
          hoverPaintStyle: { strokeWidth: "10px" },
        });
        this.anchorStartConnection = null;
        this.anchorEndConnection = null;
        if (this.outlinedNode) {
          let outlinedNode = document.getElementById(this.outlinedNode);
          outlinedNode.style.border = "";
        }
        this.oulinedNode = null;
      }
      this.shouldCreateLinks = false;
    },
    onDropUpdateData() {
      this.shouldCreateLinks = !this.shouldCreateLinks;
    },
  },
  computed: {
    canvas: {
      get() {
        return this.$store.state.canvas.canvas;
      },
      set(value) {
        this.createCanvas(value);
      },
    },
    nodes: {
      get() {
        return this.$store.state.canvas.nodes;
      },
    },
  },

};
</script>

<style scoped>
.jsPlumb-canvas {
  position: relative;
}

.canvas-controller {
  width: 10000px;
  height: 10000px;
  position: relative;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AEGCh4zPwxeRwAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAANElEQVRYw+3OQQ0AMAgEMJiuJbONk9lBxn1aBe07/1VSOnAqTEBAQEBAQEBAQEBAQEAgHlip3ARSMrcXkAAAAABJRU5ErkJggg==");
  background-repeat: repeat;
}
</style>

<style>
</style>
